import { DEVICE_STATUS_ACTIVE } from '@/config/device-status-tabs';
import { useTrackersListStatusStore } from '@/stores/useTrackersListStatusStore';

/**
 * Ensures tracker status tab UI state has a valid default on page load.
 */
export function useSynchronizedDeviceStatusQuery() {
  const statusStore = useTrackersListStatusStore();

  statusStore.ensureDefaultStatuses('trackers');
  statusStore.ensureDefaultStatuses('groupDetail');
}
